<template>
  <div class="body">
    <div class="sec1">
      <div>
        <div class="title">{{$t("available_balance")}}</div>
        <div class="num">{{balance}} {{symbol}}</div>
      </div>
      <div>
        <div class="title right">{{$t('shareValue')}}</div>
        <div class="num right">{{shareRate.toFixed(2)}}</div>
      </div>

    </div>
    <div class="detail">
      <div class="left">{{$t("winning_positions")}}</div>
      <div class="right">{{winPosition}}</div>
    </div>
    <div class="detail">
      <div class="left">{{$t("total_positions")}}</div>
      <div class="right">{{totalPosition}}</div>
    </div>
  </div>
</template>
<script>

import NoAxisLineChart from "./NoAxisLineChart.vue";
import {getHistoryData} from "../service/queryService";
import {BigNumber} from "ethers";
import {transBig2number, transNumber2Big} from "../utils/functions";
import * as echarts from "echarts";
import {createLeadingContractAndCall, createPerpOptionAndCall, getSelectTokenInfo} from "../utils/contract";
import {Method, Underling} from "../config/const";
import {getLastPrice} from "../service/priceService";
import {cacheData} from "../service/cacheService";

export default {
  components: {NoAxisLineChart},
  props:{
    contractAddress:"",
    token:""
  },
  data(){
    return {
      balance:0,
      profitValue:"7",
      chartData1:[50,50,50],
      margin:0,
      marginRate:0,
      totalPosition:0,
      winPosition:0,
      addressCount:0,
      profitIndex:0,
      profitRateArr:[0,0,0,0,0,0,0],
      profitArr:[0,0,0,0,0,0,0],
      profitRate:0,
      totalProfit:0,
      shareRate:1,
      unpnl:0,
      allFollowCount:0,
      symbol:""
    }
  },
  mounted() {
    this.getWinPosition()
    this.getProjectInfo()
  },
  methods:{
    updatePan(value, total) {
      this.margin = Number(value.pan).toFixed(2);
      if (!value.pan) {
        this.marginRate = 0;
      } else {
        this.marginRate = parseFloat((parseFloat(value.pan) * 100 / parseFloat(value.margin)).toFixed(2))
      }
      this.totalPosition = Number(total).toFixed(2);
      this.unpnl=parseFloat(value.pan);
      cacheData(this.token+"_unpnl",this.unpnl,5000);
    },
    updateAddressCount(count){
      this.addressCount=count;
    },
    calcuRate(order) {
      if (order.orderType == 1 || order.orderType == 2) {
        return "0";
      }

      let sub = BigNumber.from(0);
      if (order.direction == 1) {
        sub = BigNumber.from(order.price).sub(BigNumber.from(order.costPrice));
      } else {
        sub = BigNumber.from(order.costPrice).sub(BigNumber.from(order.price));
      }

      return transBig2number(sub.mul(order.amount).div(BigNumber.from("1000000000000000000")));
    },
    async getWinPosition(){
      let logs = await getHistoryData(this.contractAddress, 0);
      let winProfit = 0;
      let allProfit=0;
      for (let i in logs.orderHistories) {
        let item = logs.orderHistories[i];
        if (item.orderType == 3 || item.orderType == 4) {

          let profit=parseFloat(this.calcuRate(item));
          if(profit>0){
            winProfit+=profit;
          }
          allProfit+=profit;

        }
      }
      this.winPosition = winProfit.toFixed(2);
      this.totalProfit=allProfit;
      cacheData(this.token+"_allProfit",allProfit,5000);
    },

    async getProjectInfo(){
      let price = await getLastPrice()
      let priceBTC = transBig2number(price[Underling.BTC].price, price[Underling.BTC].decimal, 6);
      let priceETH = transBig2number(price[Underling.ETH].price, price[Underling.ETH].decimal, 6);

      let priceBtcNum = transNumber2Big(priceBTC);
      let priceEthNum = transNumber2Big(priceETH);
      let asset = await createLeadingContractAndCall(this.contractAddress, Method.getTotalBalance, [Underling.BTC, Underling.ETH], [priceBtcNum, priceEthNum]);
      console.log("asset is", asset);

      let totalShare = await createLeadingContractAndCall(this.contractAddress, Method.totalShare);

      if (totalShare.eq(BigNumber.from(0))) {
        this.shareRate = 0;
      } else {
        let shareValue = asset.assetAmount.mul(BigNumber.from(10000)).div(totalShare)
        this.shareRate = (parseFloat(shareValue.toString()) / 10000);
      }
      this.profitRate = this.shareRate==0?"--":((this.shareRate-1)*100).toFixed(2)

      console.log("share rate is",this.profitRate,this.shareRate);

      let followAllInfo = await createLeadingContractAndCall(this.contractAddress, Method.getAllFollowers)
      this.allFollowCount = followAllInfo.length;


      let selectToken = await getSelectTokenInfo(this.token)

      this.symbol = selectToken.symbol
      let accountInfo = await createPerpOptionAndCall(selectToken.perpetual, Method.getAccountInfo,this.token, this.contractAddress);

      if (asset.gainLoss) {
        this.balance = transBig2number(accountInfo.availableAmount)
      } else {
        this.balance = transBig2number(accountInfo.availableAmount.sub(asset.profit))
      }
    },
  },
  watch:{

  }

}

</script>

<style scoped lang="less">
  .body{
    padding-left: 15px;
    padding-right: 15px;
  }
  .sec1{
    height: 80px;
    border-radius: 6px;
    border: 0.55px solid rgba(56, 56, 56, 1);
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 20.27px;
      color: rgba(90, 90, 93, 1);
      &.right{
        text-align: right;
      }
    }
    .num{
      font-size: 18px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 21.1px;
      color: rgba(234, 236, 239, 1);
      text-align: left;
      margin-top: 8px;
      &.right{
        text-align: right;
      }
    }
  }
  .detail{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    .left{
      font-size: 13px;
      font-weight: 500;
      letter-spacing: -1px;
      line-height: 18.82px;
      color: rgba(90, 90, 93, 1);
      text-align: left;
    }
    .right{
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0px;
      line-height: 15.24px;
      color: rgba(255, 255, 255, 1);
    }
  }
  .performance{
    margin-top: 39px;
    .header{
      .title{
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 23.17px;
        color: rgba(234, 236, 239, 1);
      }
    }
    .linChartShow2{
      height: 300px;
    }
    .profit_title{
      height: 32px;
      border-radius: 16px;
      background: rgba(56, 56, 56, 1);
      display: flex;
      align-items: center;
      padding-left: 1px;
      padding-right: 1px;
      margin-top: 10px;
      .profit_rate{
        height: 30px;
        border-radius: 15px;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 30px;
        color: rgba(166, 166, 166, 1);
        flex: 1;
        text-align: center;
        &.active{
          background: rgba(22, 22, 22, 1);
        }
      }
    }
  }
</style>
<style scoped lang="scss">
.select_down {
  font-size:12px;
  color:rgba(128, 128, 128, 1);
  ::v-deep .el-input__suffix {
    .el-input__suffix-inner {
      .el-select__caret {
        font-family: 'element-icons' !important; // 确保使用 Element UI 的字体

        &.el-icon-arrow-up::before {
          content: "\e78f"; // 替换为你想用的 Element UI 图标的 Unicode 编码
        }

        &.el-icon-arrow-down::before {
          content: "\e790"; // 和展开时使用同一个图标的 Unicode
        }
      }
    }
  }
}
</style>